import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  image: {
    height: 103,
    width: 103
  }
} satisfies RecursivePartial<ProductConfig['upsell']>
